import { LayoutTableContainer } from '../orders/_layouts/LayoutTableContainer';
import { LayoutReviewContainer, LayoutReviewsBody } from '../orders/_layouts/LayoutsReviews';
import { FAQ_CATE_KR } from './_constants/const';
import { FAQ_KR } from './_constants/const';
import { Fragment, useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/atoms/Accordion';
const FAQContainer = () => {
  // 카테고리 상태
  const [selectedCate, setSelectedCate] = useState<'all' | keyof typeof FAQ_CATE_KR>('all');

  // 카테고리별 필터링
  const filteredFAQ =
    selectedCate === 'all' ? FAQ_KR : FAQ_KR.filter((item) => item.cate === selectedCate);

  return (
    <LayoutTableContainer>
      <LayoutReviewContainer>
        <LayoutReviewsBody className="">
          <div className="flex h-full w-full flex-col items-start justify-start gap-[24px]  py-[20px]">
            {/* 카테고리 선택 파트 - 카드 스타일 */}
            <div className="flex h-[46px] gap-[6px] rounded-[12px] bg-gr-100 p-[6px]">
              {Object.entries(FAQ_CATE_KR).map(([cate, label]) => (
                <div
                  key={cate}
                  className={`flex flex-1 cursor-pointer items-center justify-center rounded-[8px] px-[8px] py-[6px] text-gr-700 transition Body5M14
        ${selectedCate === cate ? 'bg-white  ' : 'bg-gr-100 text-gr-700'}
      `}
                  onClick={() => setSelectedCate(cate as keyof typeof FAQ_CATE_KR)}
                  style={{ height: 34 }}
                >
                  <span className="truncate Body5M14">{label}</span>
                </div>
              ))}
            </div>

            {/* 아코디언 FAQ 파트 */}
            <Accordion type="single" collapsible className="w-full ">
              {filteredFAQ.map((item, idx) => (
                <div key={idx}>
                  <AccordionItem value={item.q}>
                    <AccordionTrigger className="flex items-center gap-2 px-2  text-left Body2M16">
                      <div className="flex items-center">
                        {/* 카테고리 뱃지 */}
                        <span className="inline-block min-w-[120px] rounded-[6px]  px-2 py-1  text-gr-600 Body5M14">
                          {FAQ_CATE_KR[item.cate]}
                        </span>
                        {/* 질문 */}
                        <span className="text-gr-800 Body2M16">{item.q}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="mb-5 rounded-[10px] bg-gr-50 px-4 py-4 text-gr-800 Body2M16">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                  {filteredFAQ.length - 1 !== idx && <div className="h-px w-full bg-gr-200" />}
                </div>
              ))}
            </Accordion>
          </div>
        </LayoutReviewsBody>
      </LayoutReviewContainer>
    </LayoutTableContainer>
  );
};

export default FAQContainer;
